// components/ReviewApplicationModal.jsx
import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { HiOutlinePencil } from "react-icons/hi2";
import ApplicationSuccessModal from "./ApplicationSuccessModal";

const ReviewApplicationModal = ({ job, onClose }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  if (!job) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white max-h-[90vh] overflow-scroll w-full max-w-lg rounded shadow-lg p-6 relative">
          {/* Header */}
          <div className="mb-6">
            <div className="text-xs text-gray-600 font-medium">Applying to</div>
            <div className="font-semibold text-sm ">{job.title}</div>
            <div className="text-xs text-gray-500">{job.company} in {job.location}</div>
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-400 hover:text-black"
            >
              <IoClose size={22} />
            </button>
          </div>

          <h2 className="text-lg font-semibold mb-4">Review your application</h2>

          {/* About Me Section */}
          <div className="mb-4">
            <div className="flex justify-between items-center">
              <h3 className="font-semibold text-sm">About Me</h3>
              <button className="text-xs text-[#004349] flex items-center gap-1">
                <HiOutlinePencil /> Edit
              </button>
            </div>
            <ul className="text-sm text-gray-700 space-y-1 mt-1">
              <li>kelly muller</li>
              <li>Toronto, ON Canada</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="mb-4">
            <div className="flex justify-between items-center">
              <h3 className="font-semibold text-sm">Contact Information</h3>
              <button className="text-xs text-[#004349] flex items-center gap-1">
                <HiOutlinePencil /> Edit
              </button>
            </div>
            <ul className="text-sm text-gray-700 space-y-1 mt-1">
              <li>kmuller1690@gmail.com</li>
              <li>+1 705-208-0875</li>
            </ul>
          </div>

          {/* Resume Section */}
          <div className="mb-6">
            <div className="flex justify-between items-center">
              <h3 className="font-semibold text-sm">Resume</h3>
              <button className="text-xs text-[#004349] flex items-center gap-1">
                <HiOutlinePencil /> Edit
              </button>
            </div>
            <div className="text-sm text-gray-700 mt-2">
              Stephan Graham Resume.docx
            </div>
            <div className="mt-2 border rounded overflow-hidden">
              <img
                src="https://i.ibb.co/Y28gbZB/resume-sample.png"
                alt="Resume Thumbnail"
                className="w-full object-cover"
              />
            </div>
          </div>

          <button
            className="w-full bg-black hover:bg-black text-white font-semibold py-2 rounded text-sm"
            onClick={() => setShowSuccess(true)}
          >
            Submit
          </button>
        </div>
      </div>

      {showSuccess && <ApplicationSuccessModal job={job} onClose={() => setShowSuccess(false)} />}
    </>
  );
};

export default ReviewApplicationModal;
